/* 局外進度的持久化。這是三個接縫之一。 */

/* ---------- 存檔 ----------
   原本接的是 window.storage（Claude 執行環境專用），註解自陳「本機請自行接 localStorage」，
   所以在一般瀏覽器裡局外進度根本不會被保存。M2 改接 localStorage。
   loadMeta 保留 callback 形式，呼叫端不用改。 */
export var META = {
  kills: 0, bestStage: 0, runs: 0, wins: 0, revives: 1, mechs: ['chassis0'], tier2: false,
  /* 局外部件（M10）。**兩張表都以機體 id 為第一層 key**（使用者 2026-08-05 指定
     「兩台各自一套系統、互不共用」）：
       owned = 機體id → 部件id → 等級（1–5）
       equip = 機體id → 部位 → 部件id
     廢料 `scrap` 仍是全域的一個池子 —— 分開存的話玩家會有兩份看不懂的餘額。
     代價是部件的總需求變兩倍，這是設計上接受的（起手件成本 0，
     新解鎖的機體一樣是「局外等級 0」的可玩狀態，不會光溜溜）。 */
  scrap: 0,
  owned: {} as Record<string, Record<string, number>>,
  equip: {} as Record<string, Record<string, string>>,
  /* 圖鑑的三段解鎖（使用者 2026-08-02 指定）：
       沒看過 → 大問號　看過沒打死 → 黑影＋家族　打死過 → 全開
     兩張表分開存而不是存一個狀態碼，因為「遭遇 47 次但一次都沒打死」
     本身就是情報 —— 那句話會讓玩家知道自己一直在躲某一隻。
     key = 型別 id，值是次數。 */
  seen: {} as Record<string, number>,
  killed: {} as Record<string, number>
};

/** 遇到一隻（生成時記）。**不寫 localStorage** —— 一場會叫幾萬次，
    落地交給既有的 `saveMeta()`（結算時會呼叫）。 */
export function logSeen(id) { META.seen[id] = (META.seen[id] || 0) + 1; }
/** 打死一隻。看過與打死是兩件事，所以兩張表都要記。 */
export function logKilled(id) { META.killed[id] = (META.killed[id] || 0) + 1; }
/** 精英形式的解鎖 key。**精英與一般版各自解鎖**（使用者 2026-08-03 指定）——
    看過精英不等於看過一般版，反過來也一樣，所以兩者各記各的。
    後綴用 `@e` 而不是新開一張表：`codexStage()` 認的是 key，不是型別。 */
export function eliteKey(id) { return id + '@e'; }

/** 圖鑑的解鎖階段：0 沒看過 / 1 看過沒打死 / 2 打死過。 */
export function codexStage(id) {
  if (META.killed[id] > 0) return 2;
  if (META.seen[id] > 0) return 1;
  return 0;
}
export var SAVE_KEY = 'chassis0:meta:v3';   // v3：加入局外部件
export function saveMeta() {
  try {
    localStorage.setItem(SAVE_KEY, JSON.stringify(META));
  } catch (e) { /* 隱私模式或容量已滿：本次工作階段仍有效 */ }
}

export function loadMeta(done) {
  try {
    var raw = localStorage.getItem(SAVE_KEY);
    if (raw) { var m = JSON.parse(raw); for (var k in m) if (META.hasOwnProperty(k)) META[k] = m[k]; }
  } catch (e) { /* 讀不到就用預設值 */ }
  migrateParts();
  done();
}

/** 部件表從「全域一套」升級成「每台機體一套」的就地遷移。

    **不換 SAVE_KEY**，改用形狀判斷：舊格式 `owned` 的值是數字、`equip` 的值是
    字串；新格式兩者的值都是物件。這樣舊存檔一載入就自動長成新樣子，
    而且遷移是冪等的（跑第二次什麼都不做）。

    舊的一套全部歸給 CHASSIS-0 —— 它是預設解鎖的那台，玩家原本買的東西
    也確實是為它買的。 */
export function migrateParts() {
  var o: any = META.owned, e: any = META.equip;
  var k;
  for (k in o) { if (typeof o[k] === 'number') { META.owned = { chassis0: o } as any; } break; }
  for (k in e) { if (typeof e[k] === 'string') { META.equip = { chassis0: e } as any; } break; }
}
/** 機體的解鎖門檻（累計擊墜）與解鎖時的告示文字。
    **這是單一事實來源** —— 機庫卡片的鎖定文案（`ui/hangar-panel.ts`）讀同一張表。
    以前那句「累計擊墜 400」寫死在 UI 裡，第二台以後就會說謊。

    順序是「均衡 → 極端的快 → 極端的慢」：TITAN-3 的門檻高一階，
    留給已經摸熟節奏、想換一種打法的玩家。 */
export var MECH_KILLS: any = { lancer2: 400, titan3: 900 };
var MECH_NOTE: any = { lancer2: '新機體 · LANCER-2 斬型', titan3: '新機體 · TITAN-3 壯漢型' };

export function checkUnlocks() {
  var got = [];
  for (var id in MECH_KILLS) {
    if (META.kills >= MECH_KILLS[id] && META.mechs.indexOf(id) < 0) { META.mechs.push(id); got.push(MECH_NOTE[id]); }
  }
  /* 復活數的解鎖有兩個觸發條件，同一場可能一起達成 ——
     報「+1」的話畫面上會出現「起始復活 +1、起始復活 +1」，看起來像重複的 bug
     （其實真的加了 2）。改報結果值就沒有歧義。 */
  if (META.bestStage >= 2 && META.revives < 2) { META.revives = 2; got.push('起始復活 → 2'); }
  if (META.kills >= 1200 && !META.tier2) { META.tier2 = true; got.push('高階模組解禁'); }
  if (META.wins >= 1 && META.revives < 3) { META.revives = 3; got.push('起始復活 → 3'); }
  saveMeta();
  return got;
}
